<template>
  <IframeCmp type="121" />
</template>

<script>
import IframeCmp from './cmp/IframeCmp';

export default {
  // 已签收报表明细
  name: 'ReceivedReportDetails',
  components: {
    IframeCmp
  },
  data() {
    return {

    };
  }
};
</script>

<style scoped></style>
